import React from 'react'
import { TrackingStatus } from './TrackingStatus'

const ProductDetails = () => (
  <div className='product-infos col-12 mx-0'>
    <TrackingStatus ready={false} />
    <div className='row'>
      <div className='col-10 py-half bg-ui-4 radius mt-1' />
    </div>
    <div className='row mt-1'>
      <div className='col-5 py-half bg-ui-4 radius' />
    </div>
    <div className='row mt-1'>
      <div className='col-5 py-half bg-ui-4 radius' />
    </div>
  </div>
)

export default ProductDetails



// WEBPACK FOOTER //
// ./src/Participant/MyOrders/ProductOrderList/ProductOrderItem/ProductDetails/Placeholder.js